
export default function BookingProcess() {
  const steps = [
    {
      number: '01',
      title: 'Choose Your Vehicle',
      description: 'Browse our extensive fleet online or visit one of our rental locations. Select from economy cars, luxury sedans, SUVs, or commercial vehicles.',
      icon: 'ri-car-line'
    },
    {
      number: '02',
      title: 'Make Your Reservation',
      description: 'Book online, by phone, or in-person. Provide your driver\'s license, credit card, and rental preferences. Instant confirmation available.',
      icon: 'ri-calendar-check-line'
    },
    {
      number: '03',
      title: 'Pick Up Your Rental',
      description: 'Visit our location at your scheduled time. Complete the rental agreement, inspect the vehicle, and receive your keys from our professional staff.',
      icon: 'ri-key-line'
    },
    {
      number: '04',
      title: 'Enjoy Your Journey',
      description: 'Drive with confidence knowing you have 24/7 roadside assistance, comprehensive insurance options, and professional support throughout your rental.',
      icon: 'ri-road-map-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            Simple Rental Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our streamlined rental process makes it easy to get on the road quickly. 
            Professional service from reservation to return.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center group">
              <div className="relative mb-8">
                <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-700 transition-colors duration-300">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <span className="text-sm font-bold text-blue-600">{step.number}</span>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-gray-200 transform -translate-y-1/2"></div>
                )}
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gray-50 rounded-2xl p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                Professional Requirements
              </h3>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  Valid driver's license (minimum age 21)
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  Major credit card in renter's name
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  Proof of insurance (or purchase our coverage)
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  Additional ID for international renters
                </li>
              </ul>
            </div>
            <div className="text-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/8d1d4eb750c22fe4f988fadaafe5df75.jpg"
                alt="Professional car rental service"
                className="rounded-lg shadow-lg w-full h-64 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
